<template>
	<div class="change-form">
        <div slot="header" class="header">
            <h4>Change Name</h4>
        </div>
        <div class="change-section">
            <h5>New Name</h5>
            <!-- <el-input placeholder="Please input" v-model="newName">
            </el-input>-->

            <el-input placeholder="Please input" @focus="removeValidation" v-model="newName" size="small">
                <template v-if="changedName" slot="append">
                    <el-button type="success" @click="nameChange" size="small">
                        Update Name
                    </el-button>
                </template>
            </el-input>
            <div v-if="showValidation" class="validation">{{ validationText }}</div>
            <ChangeButtons @change="nameChange" @cancel="cancel" ></ChangeButtons>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ChangeButtons from './ChangeButtons'

export default {
	name: 'change-email',

	data() {
		return {
            newName: null,
            showValidation: false
		}
    },
	watch: {
		// newName(value) {
		// 	if (value == null)
		// 		this.newName = this.user.name
		// }
    },
    mounted() {
        this.newName = this.user.name
    },
    methods: {
        nameChange() {
            if (this.newName == this.user.name) {
                this.showValidation = true
            }
            else {
                this.$emit('change', {
                    name: this.newName
                })
            }
		},
		cancel() {
			this.$emit('cancel')
        },
		removeValidation() {
			this.showValidation = false
		}
    },
	computed: {
		...mapState('user', [
			'user'
		]),
		changedName() {
			return this.newName != this.user.name
        },
        validationText() {
            return 'Cannot change to already registered name'
        }
    },
    components: {
        ChangeButtons
    }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>